import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormRadioContainer from 'components/cef_form/hook-form/HookFormRadioContainer';

const CreditRadios = () => {
  const creditRadioItems = [
    {
      id: 'yes',
      label: 'Yes',
      value: false,
    },
    {
      id: 'no',
      label: 'No',
      value: true,
    },
  ];

  return (
    <InnerFormSection>
      <HookFormRadioContainer
        direction="horizontal"
        variant="feature"
        id="account_cash_only"
        label="Do you want to apply for Credit?"
        description="We will perform a full credit check for your account application"
        radioItems={creditRadioItems}
      />
    </InnerFormSection>
  );
};
export default CreditRadios;
